import { ReactElement, useState } from "react";

export default function ImageCard({ src, children }: { src: string; children?: ReactElement }) {
	const [showModal, setShowModal] = useState(false);

	return (
		<>
			<div className="card mb-3 p-2">
				<div
					className="ratio ratio-16x9 position-relative"
					onClick={() => setShowModal(true)}
					style={{ cursor: "pointer" }}
				>
					<img src={src} className="card-img-top object-fit-cover" alt="Detail" />
				</div>

				{children ? children : null}
			</div>
			{showModal && (
				<div
					className="modal fade show d-block"
					tabIndex={-1}
					role="dialog"
					onClick={() => setShowModal(false)}
					style={{
						backgroundColor: "rgba(0, 0, 0, 0.85)",
						position: "fixed",
						top: 0,
						left: 0,
						width: "100%",
						height: "100%",
						zIndex: 1050,
					}}
				>
					<div className="d-flex justify-content-center align-items-center h-100">
						<img
							src={src}
							alt="Full preview"
							className="img-fluid"
							style={{ maxHeight: "90%", maxWidth: "90%", cursor: "pointer" }}
							onClick={() => setShowModal(false)}
						/>
					</div>
				</div>
			)}
		</>
	);
}
